const data = {
    mainTitle: <>Good food for all</>,
    mainDescription: `Our family is growing. Chobani, La Colombe, and Daily Harvest — three brands, one belief: that food should be delicious, nutritious, and made for everyone. Real ingredients. Made right. More ways than ever to enjoy them.`,
    products: [
        {
            id: 'complete_drinks',
            name: 'High Protein Greek Yogurt Drinks',
            image: '/images/products-02-26/EXPO_2026_Soccer_CHO_HiPro_Drinks_Thumbnail_340x340px_v1.png',

            sheets: [
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_HiPro_Drinks_v9-1.jpg',
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_HiPro_Drinks_v9-2.jpg',
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_HiPro_Drinks_v9-3.jpg',
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_HiPro_Drinks_v9-4.jpg',
            ],
            pdf: '/sheets/2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_HiPro_Drinks_v9.pdf',
        },
        {
            id: 'complete_drinks_cups',
            name: 'High Protein Greek Yogurt',
            image: '/images/products-02-26/EXPO_2026_Soccer_CHO_HiPro_Cups_Thumbnail_340x340px_v1.png',

            sheets: [
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_HiPro_Cups_v10-1.jpg',
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_HiPro_Cups_v10-2.jpg',
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_HiPro_Cups_v10-3.jpg',
            ],
            pdf: '/sheets/2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_HiPro_Cups_v10.pdf',
        },
        {
            id: 'greek-yogurt-cups',
            name: 'Greek Yogurt Cups',
            image: '/images/products-02-26/EXPO_2026_Soccer_CHO_Core_Cups_Thumbnail_340x340px_v1.png',

            sheets: [
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_GRK_Cups_v9-1.jpg',
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_GRK_Cups_v9-2.jpg',
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_GRK_Cups_v9-3.jpg',
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_GRK_Cups_v9-4.jpg',
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_GRK_Cups_v9-5.jpg',
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_GRK_Cups_v9-6.jpg',
            ],
            pdf: '/sheets/2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_GRK_Cups_v9.pdf',
        },
        {
            id: 'lc_draft_latte_11oz',
            name: 'Draft Latte 11oz',
            image: '/images/products-02-26/EXPO_2026_Soccer_LC_11oz_Thumbnail_340x340px_v1.png',

            sheets: [
                '/images/sheets2026-02/LC26-EXPOWEST_SELLSHEET_11ozCans_v6-01.jpg',
                '/images/sheets2026-02/LC26-EXPOWEST_SELLSHEET_11ozCans_v6-02.jpg',
                '/images/sheets2026-02/LC26-EXPOWEST_SELLSHEET_11ozCans_v6-03.jpg',
                '/images/sheets2026-02/LC26-EXPOWEST_SELLSHEET_11ozCans_v6-04.jpg',
            ],

            pdf: '/sheets/2026-02/LC26-EXPOWEST_SELLSHEET_11ozCans_v6-96max.pdf',
        },
        /*
        {
            id: 'lc_draft_latte_9oz',
            name: 'Draft Latte 9oz',
            image: '/images/products_la_colombe/LCDraftLatte-10-25.png',

            sheets: [
                '/images/sheets2025/LC25_EXPOWest-SellSheet_9ozCans_FINAL-1.png',
                '/images/sheets2025/LC25_EXPOWest-SellSheet_9ozCans_FINAL-2.png',
                '/images/sheets2025/LC25_EXPOWest-SellSheet_9ozCans_FINAL-3.png',
                '/images/sheets2025/LC25_EXPOWest-SellSheet_9ozCans_FINAL-4.png',
            ],

            pdf: '/sheets/2025/LC25_EXPOWest-SellSheet_9ozCans_FINAL.pdf',
        },
        {
            id: 'lc_draft_latte_4pk',
            name: 'Draft Latte 4-Packs',
            image: '/images/products_la_colombe/LCColdBrew4pack.png',

            sheets: [
                '/images/sheets2025/LC25_EXPOWest-SellSheet_9oz4Pack_FINAL-1.png',
                '/images/sheets2025/LC25_EXPOWest-SellSheet_9oz4Pack_FINAL-2.png',
                '/images/sheets2025/LC25_EXPOWest-SellSheet_9oz4Pack_FINAL-3.png',
                '/images/sheets2025/LC25_EXPOWest-SellSheet_9oz4Pack_FINAL-4.png',
            ],

            pdf: '/sheets/2025/LC25_EXPOWest-SellSheet_9oz4Pack_FINAL.pdf',
        },
        */
        {
            id: 'cold_brew_multi_serve',
            name: 'Cold Brew Multiserve',
            image: '/images/products-02-26/EXPO_2026_Soccer_LC_48oz_Thumbnail_340x340px_v1.png',

            sheets: [            
                '/images/sheets2026-02/LC26-EXPOWEST_SELLSHEET_48oz_MS_v4-01.jpg',
                '/images/sheets2026-02/LC26-EXPOWEST_SELLSHEET_48oz_MS_v4-02.jpg',
            ],

            pdf: '/sheets/2026-02/LC26-EXPOWEST_SELLSHEET_48oz_MS_v3.pdf',
        },
        {
            id: 'greek_yogurt_drinks',
            name: 'Greek Yogurt Drinks',
            image: '/images/products-02-26/EXPO_2026_Soccer_CHO_Core_Drinks_Thumbnail_340x340px_v1.png',
            sheets: [
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_Drinks_v9-1.jpg','/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_Drinks_v9-2.jpg',
            ],
            pdf: '/sheets/2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_Drinks_v9.pdf',
        },
        {
            id: 'dairy_creamer',
            name: 'Dairy Creamer',
            image: '/images/products_expo24/DairyCreamer_Expo24.png',

            sheets: [
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_Creamer_v2-1.jpg',
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_Creamer_v2-2.jpg',
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_Creamer_v2-3.jpg',
                '/images/sheets2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_Creamer_v2-4.jpg',
            ],
            pdf: '/sheets/2026-02/SALES_TM_2026_EXPO_WEST_Sell-Sheets_Creamer_v2.pdf',
        },
        {
            id: 'daily_harvest',
            name: 'Daily Harvest',
            image: '/images/products-02-26/dh-protein-smoothie.png',

            sheets: [
                '/images/sheets2026-02/Daily_Harvest-expo-sell-sheet-1_Page_1.png',
                '/images/sheets2026-02/Daily_Harvest-expo-sell-sheet-1_Page_2.png',
                '/images/sheets2026-02/Daily_Harvest-expo-sell-sheet-1_Page_3.png',
                '/images/sheets2026-02/Daily_Harvest-expo-sell-sheet-1_Page_4.png',
                '/images/sheets2026-02/Daily_Harvest-expo-sell-sheet-1_Page_5.png',
                '/images/sheets2026-02/Daily_Harvest-expo-sell-sheet-1_Page_6.png',
                '/images/sheets2026-02/Daily_Harvest-expo-sell-sheet-1_Page_7.png',
                '/images/sheets2026-02/Daily_Harvest-expo-sell-sheet-1_Page_8.png',
            ],
            pdf: '/sheets/2026-02/Daily_Harvest-expo-sell-sheet-1.pdf',
        },
        /*
        {
            id: 'oatmilk',
            name: 'Oatmilk',
            image: '/images/products/OatmilkOriginal.png',

            sheets: [
                '/images/sheets2025/SALES_TM_2025_Expo-West-Sell-Sheets_Oatmilk_v10-1.png',
                '/images/sheets2025/SALES_TM_2025_Expo-West-Sell-Sheets_Oatmilk_v10-2.png',
                '/images/sheets2025/SALES_TM_2025_Expo-West-Sell-Sheets_Oatmilk_v10-3.png',
            ],
            pdf: '/sheets/2025/SALES_TM_2025_Expo-West-Sell-Sheets_Oatmilk_v10.pdf',
        },
        */

        // {
        //     id: 'barista_oatmilk',
        //     name: 'Barista Oatmilk',
        //     image: '/images/products_expo24/BaristaOatmilk_Expo24.png',
        //     // smallText: 'Packaging art not final.',

        //     sheets: [
        //         '/images/sheets/SALES_TM_2024_NACS-Sell-Sheets_Barista_v2_Page_1.png',
        //         '/images/sheets/SALES_TM_2024_NACS-Sell-Sheets_Barista_v2_Page_2.png',
        //     ],
        //     pdf: '/sheets/SALES_TM_2024_NACS-Sell-Sheets_Barista_v2.pdf',
        // },

        /*
        {
            id: 'creations',
            name: 'Creations™',
            image: '/images/products_expo24/Creations_Expo24.png',

            sheets: [
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Creations_v1-1.png',
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Creations_v1-2.png',
            ],
            pdf: '/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Creations_v1',
        },
        {
            id: 'flip',
            name: 'Flip®',
            image: '/images/products_expo24/Flip_Expo24.png',

            sheets: [
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Flip_v2-1.png',
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Flip_v2-2.png',
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Flip_v2-3.png',
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Flip_v2-4.png',
            ],

            pdf: '/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Flip_v2.pdf',
        },
        {
            id: 'less_sugar',
            name: 'Less Sugar*',
            image: '/images/products_expo24/LessSugar_Expo24.png',

            sheets: [
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_LSG_v1-1.png',
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_LSG_v1-2.png',
            ],
            pdf: '/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_LSG_v1.pdf',
        },
        {
            id: 'multi_serve',
            name: 'Multi-Serve',
            image: '/images/products_expo24/MultiServe_Expo24.png',

            sheets: [
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Core_v1-1.png',
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Core_v1-2.png',
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Core_v1-3.png',
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Core_v1-4.png',
            ],

            pdf: '/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Core_v1.pdf',
        },
        
        {
            id: 'oatmilk_limited_batch',
            name: 'Oatmilk Limited Batch',
            image: '/images/products_expo24/CRLMK_Oatmilk_SCA24.png',

            sheets: [
                '/images/sheets/SALES_TM_2024_Sell-Sheets_Oatmilk-1.png',
                '/images/sheets/SALES_TM_2024_Sell-Sheets_Oatmilk-2.png',
                '/images/sheets/SALES_TM_2024_Sell-Sheets_Oatmilk-3.png',
                '/images/sheets/SALES_TM_2024_Sell-Sheets_Oatmilk-4.png',
                '/images/sheets/SALES_TM_2024_Sell-Sheets_Oatmilk-5.png',
                '/images/sheets/SALES_TM_2024_Sell-Sheets_Oatmilk-6.png',
            ],
            pdf: '/sheets/SALES_TM_2024_Sell-Sheets_Oatmilk.pdf',
        },
        {
            id: 'zero_sugar',
            name: 'Zero Sugar**',
            image: '/images/products_expo24/ZeroSugar_Expo24.png',

            sheets: [
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_ZS_v1-1.png',
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_ZS_v1-2.png',
            ],

            pdf: '/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_ZS_v1.pdf',
        },
        {
            id: 'zero_sugar_drinks',
            name: 'Zero Sugar** Drinks',
            image: '/images/products_expo24/ZeroSugarDrinks_Expo24.png',
            sheets: [
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Drinks_v1-1.png',
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Drinks_v1-2.png',
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Drinks_v1-3.png',
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Drinks_v1-4.png',
                '/images/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Drinks_v1-5.png',
            ],
            pdf: '/sheets/SALES_TM_2024_Expo-West-Sell-Sheets_Drinks_v1.pdf',
        },
        {
            id: 'lc_cold_brew_42oz',
            name: 'Cold Brew 42oz',
            image: '/images/products_la_colombe/LC_42oz_Comp_MediumUnsweet_Expo24.png',

            sheets: [
                '/images/sheets_la_colombe/LC-EXPOWEST-SELLSHEET_42ozMULTISERVE-1.png',
                '/images/sheets_la_colombe/LC-EXPOWEST-SELLSHEET_42ozMULTISERVE-2.png',
            ],

            pdf: '/sheets/LC-EXPOWEST-SELLSHEET_42ozMULTISERVE.pdf',
        },
        {
            id: 'lc_coffee_beans',
            name: 'Roasted Coffee',
            image: '/images/products_la_colombe/LC_New_12oz_Packaging_redesign_cutouts_Corsica_Expo24.png',

            sheets: [
                '/images/sheets_la_colombe/LC_EXPOWEST_SELLSHEET_ROASTED_v2-1.png',
                '/images/sheets_la_colombe/LC_EXPOWEST_SELLSHEET_ROASTED_v2-2.png',
            ],

            pdf: '/sheets/LC_EXPOWEST_SELLSHEET_ROASTED_v2.pdf',
        },
        {
            id: 'lc_k_cup_pods',
            name: 'K-Cup Pods',
            image: '/images/products_la_colombe/LC_Corsica_K-Cup_Amzn3Q_Expo24.png',

            sheets: [
                '/images/sheets_la_colombe/LC_EXPOWEST_SELLSHEET_KCUP_-1.png',
                '/images/sheets_la_colombe/LC_EXPOWEST_SELLSHEET_KCUP_-2.png',
            ],

            pdf: '/sheets/LC_EXPOWEST_SELLSHEET_KCUP_.pdf',
        },
        */
    ],

    footer: (
        <>
            <br />
        </>
    ),

    copyright: '© March 2026 Chobani, LLC. All Rights Reserved.',
}

export default data
